import type {
  Id,
  ModelOption,
  Product,
  SelectedOptions,
} from "@/configurator/domain/models/types";
import type {
  ModelOptionView,
  OptionGroupView,
} from "@/configurator/domain/models/view";
import { getSelectedOptionIds } from "./selection";

/**
 * Every option group with its current selection already resolved, so the panel
 * renders rows instead of re-deriving them from group kinds and default ids.
 */
export function buildOptionGroupViews(
  product: Product | undefined,
  selected: SelectedOptions,
): OptionGroupView[] {
  if (!product) return [];

  return product.optionGroups.map((group) => {
    const selectedIds = getSelectedOptionIds(group, selected);

    return {
      id: group.id,
      label: group.label,
      kind: group.kind,
      // Only `gridOptions` lets several options be on at once; every other kind
      // is a pick. The panel needs the answer, not the kind it follows from.
      multiple: group.kind === "gridOptions",
      items: group.options.map((option) => ({
        id: option.id,
        label: option.label,
        selected: selectedIds.includes(option.id),
        color: "color" in option ? option.color : undefined,
        texture: "texture" in option ? option.texture : undefined,
      })),
    };
  });
}

export function buildModelOptionViews(
  options: ModelOption[],
  activeModelId: Id | undefined,
): ModelOptionView[] {
  return options.map((option) => ({
    id: option.id,
    label: option.label,
    selected: option.id === activeModelId,
  }));
}
